/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './global-banner';
import './global-banner-heading';
import './global-banner-copy';
import './global-banner-image';
import '../button/index';
import '../link-with-icon/index';
